import { KalturaHouseholdDeviceListResponse } from '@kaltura-ott/ott-client-types';
import { KalturaHouseholdDevice, KalturaStreamingDeviceListResponse } from '@kaltura-ott/ott-client-types/api/types';

import { HouseholdStreamingDevices } from '../interfaces/household';

export const mergeDevicesWithStreamingDevices = (
  deviceList: KalturaHouseholdDeviceListResponse,
  streamingDeviceList: KalturaStreamingDeviceListResponse,
): HouseholdStreamingDevices => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const devices: (KalturaHouseholdDevice & any)[] = [];

  const streamingDeviceIdsSet = new Set();
  streamingDeviceList?.objects.forEach((streamingDevice) => streamingDeviceIdsSet.add(streamingDevice.udid));

  deviceList.objects.forEach((device) => {
    devices.push({
      ...device,
      isStreaming: streamingDeviceIdsSet.has(device.udid),
    });
  });
  return {
    totalCount: deviceList.totalCount,
    objects: devices,
  };
};
